<template>
  <div class="mobile-left-panel-inner">
    <ul class="menu-items pa-0" style="position: fixed;">
      <div v-for="menu in menuList" :key="menu.id">
        <li :class="menu.class1" @click="setActiveId(menu)">
          <router-link
            :class="menu.class2"
            class="text"
            to=""
            @click.native="selectMenu(menu)"
          >
            <i :class="menu.icon" />
            {{ menu.name }}
          </router-link>
        </li>
      </div>
    </ul>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "LeftBar",
  data() {
    return {
      previousActiveId: 1,
      menuList: [
        {
          id: 1,
          name: "Media",
          icon: "icon news-feed-icon",
          path: "/newsfeed",
          class1: "active",
          class2: "active-bg",
          class3: "active-pipe"
        },
        {
          id: 2,
          name: "Find Doctor",
          icon: "icon search-icon",
          path: "/findDoctor",
          class1: "",
          class2: "",
          class3: ""
        },
        {
          id: 3,
          name: "Bookings",
          icon: "icon schedule-icon",
          path: "/appointment/list",
          class1: "",
          class2: "",
          class3: ""
        },
        {
          id: 4,
          name: "Profile",
          icon: "icon profile-icon",
          path: "/profile",
          class1: "",
          class2: ""
        }
      ],
      menuItem: {}
    };
  },
  computed: {
    ...mapGetters("user", {
      user: "user"
    })
  },
  watch: {
    $route(routeVal) {
      this.findCurrentRoute(routeVal.meta.module);
    },
    "$route.meta.module": function(module) {
      const isPath = element => element.name === module;
      const index = this.menuList.findIndex(isPath);
      const menuItem = this.menuList[index];
      this.setActiveId(menuItem);
    }
  },
  created() {
    this.$bus.$on("setActiveId", data => {
      this.setActiveId(data);
    });
  },
  mounted() {
    this.findCurrentRoute(this.$route.meta.module);
  },
  methods: {
    findCurrentRoute(module) {
      const isPath = element => element.name === module;
      const index = this.menuList.findIndex(isPath);
      this.menuItem = this.menuList[index];
      this.setActiveId(this.menuItem);
      // const UserType = this.user.userType ? this.user.userType : '';
    },
    selectMenu(menu) {
      if (typeof menu === "undefined") {
        this.setDefaultMenuItem();
        return;
      }
      if (this.previousActiveId === menu.id) return;
      this.$router.push({ path: menu.path }).catch(() => {});
    },
    setDefaultMenuItem() {
      this.menuList.forEach(item => {
        item.class1 = "";
        item.class2 = "";
        item.class3 = "";
      });
      const defaultMenu = this.menuList[4];
      defaultMenu.class1 = "active";
      defaultMenu.class2 = "active-bg";
      this.previousActiveId = defaultMenu.id;
    },
    setActiveId(menu) {
      if (typeof menu === "undefined") {
        this.menuList.forEach(item => {
          item.class1 = "";
          item.class2 = "";
          item.class3 = "";
        });
        this.menuList[0].class1 = "active";
        return;
      }
      if (
        this.previousActiveId === "undefined" &&
        this.previousActiveId === menu.id
      ) {
        return;
      }

      this.menuList.find(item => item.id === this.previousActiveId).class1 = "";
      this.menuList.find(item => item.id === this.previousActiveId).class2 = "";
      this.menuList.find(item => item.id === this.previousActiveId).class3 = "";

      this.menuList.find(item => item.id === menu.id).class1 = "active";
      this.menuList.find(item => item.id === menu.id).class2 = "active-bg";
      this.menuList.find(item => item.id === menu.id).class3 = "active-pipe";

      this.menuList.find(item => item.id !== menu.id).class1 = "";
      this.menuList.find(item => item.id !== menu.id).class2 = "";
      this.menuList.find(item => item.id !== menu.id).class3 = "";
      this.previousActiveId = menu.id;
    }
  }
};
</script>

<style lang="scss">
.fixed {
  position: fixed;
  z-index: 100;
}
.header-logo {
  position: absolute;
  width: 72px;
  height: 27px;
  left: 12px;
  top: 32px;
}
.mobile-left-panel-inner a {
  display: grid !important;
  text-align: center !important;
  color: #2f4c67 !important;
  font-weight: 500;
  font-size: 12px;
  line-height: 14px;
  letter-spacing: 0.25px;
}
.mobile-left-panel-inner a.active-bg {
  color: #122d4f !important;
}
</style>
